module.exports = __webpack_public_path__ + "img/gongdan2.e3fefd46.jpg";